// A2-537 U4 — the order a country form's sections render in.
//
// Sections keep the payload's first-seen order (v0.4.63: no per-country
// list in the frontend), except that a section with no box carrying a form
// number goes after the numbered ones. Such a section holds the operator's
// workings — on the UK form, the import VAT and reverse-charge figures
// that feed Boxes 1, 4 and 6 — and showed above Box 1, so the form read
// top-down did not start where the HMRC return does. A form where no box
// has a number keeps its order unchanged.
export function formSectionOrder(boxes) {
  const order = [];
  const numbered = new Set();
  for (const b of boxes || []) {
    const sec = b.section || "_default";
    if (!order.includes(sec)) order.push(sec);
    if (b.display_ref) numbered.add(sec);
  }
  return [...order.filter((s) => numbered.has(s)), ...order.filter((s) => !numbered.has(s))];
}
